(() => {
  const dialog = document.querySelector('#PawWishlistDialog');
  if (!dialog) return;
  const key = 'pawcore-wishlist-v1';
  const list = dialog.querySelector('[data-wishlist-items]');
  const empty = dialog.querySelector('[data-wishlist-empty]');
  const escape = value => String(value || '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const safeProductUrl = raw => {
    if (typeof raw !== 'string' || raw.length > 2048 || /[\x00-\x20\x7f]/.test(raw)) return '';
    try {
      const url = new URL(raw, location.origin);
      if (url.origin !== location.origin || !/^https?:$/.test(url.protocol) || url.username || url.password || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+\/?$/.test(url.pathname)) return '';
      return url.pathname + url.search + url.hash;
    } catch (_) { return ''; }
  };
  const safeImageUrl = raw => {
    if (typeof raw !== 'string' || raw.length > 2048 || /[\x00-\x20\x7f]/.test(raw)) return '';
    try {
      const url = new URL(raw, location.origin);
      if (url.protocol !== 'https:' || url.username || url.password || (url.origin !== location.origin && url.hostname !== 'cdn.shopify.com' && url.hostname !== 'cdn.shopifycdn.net')) return '';
      return url.href;
    } catch (_) { return ''; }
  };
  const normalize = item => {
    if (!item || typeof item.handle !== 'string' || !/^[a-z0-9-]{1,255}$/.test(item.handle)) return null;
    const url = safeProductUrl(item.url);
    if (!url) return null;
    return {handle: item.handle, url, image: safeImageUrl(item.image), title: String(item.title || '').slice(0, 300), price: String(item.price || '').slice(0, 80)};
  };
  const load = () => {
    try {
      const items = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(items) ? items.slice(0, 100).map(normalize).filter(Boolean) : [];
    } catch (_) { return []; }
  };
  let items = load();
  const render = () => {
    const handles = new Set(items.map(item => item.handle));
    document.querySelectorAll('[data-wishlist-save]').forEach(button => {
      const saved = handles.has(button.dataset.wishlistHandle);
      button.classList.toggle('is-saved', saved);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', (saved ? 'Remove ' : 'Save ') + button.dataset.wishlistTitle + (saved ? ' from wishlist' : ' to wishlist'));
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(count => {
      count.textContent = items.length;
      count.hidden = !items.length;
    });
    empty.hidden = items.length > 0;
    list.innerHTML = items.map(item => `<article class="paw-wishlist-item"><a href="${escape(item.url)}">${item.image ? `<img src="${escape(item.image)}" alt="" width="76" height="76" loading="lazy">` : ''}<span><strong>${escape(item.title)}</strong><small>${escape(item.price)}</small></span></a><button type="button" data-wishlist-remove="${escape(item.handle)}" aria-label="Remove ${escape(item.title)} from wishlist">Remove</button></article>`).join('');
  };
  document.addEventListener('click', event => {
    const save = event.target.closest('[data-wishlist-save]');
    if (save) {
      const handle = save.dataset.wishlistHandle;
      if (!handle) return;
      if (items.some(item => item.handle === handle)) items = items.filter(item => item.handle !== handle);
      else {
        const item = normalize({handle, url: save.dataset.wishlistUrl, title: save.dataset.wishlistTitle, image: save.dataset.wishlistImage, price: save.dataset.wishlistPrice});
        if (!item) return;
        items.unshift(item);
        items = items.slice(0, 100);
      }
      try { localStorage.setItem(key, JSON.stringify(items)); } catch (_) {}
      render();
      return;
    }
    const remove = event.target.closest('[data-wishlist-remove]');
    if (remove) {
      items = items.filter(item => item.handle !== remove.dataset.wishlistRemove);
      try { localStorage.setItem(key, JSON.stringify(items)); } catch (_) {}
      render();
    }
  });
  document.querySelectorAll('[data-wishlist-open]').forEach(button => button.addEventListener('click', () => {
    items = load();
    render();
    if (!dialog.open) dialog.showModal();
  }));
  dialog.querySelector('[data-wishlist-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  window.addEventListener('storage', event => { if (event.key === key) { items = load(); render(); } });
  render();
})();

